const images = {
    turn_off : require('./turn-off.png'),
    sysco_white : require('./Sysco_White.png'),
    header:require('./header.png'),
    user_login_info:require('./user_login_info.png')
};

export default images;